import React from 'react';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import Colors from 'enums/Colors';
import { ColumnsType } from 'antd/es/table';
import Quote from 'pages/ebooks/components/Quote';
import CardQRcodeVideosPlanoAnual from '../../components/CardQRcodeVideosPlanoAnual';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

interface DataType {
    key: string;
    name: string;
    solucoes: string;
    // estudantes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais.
        `,
    },
    {
        key: '2',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
    {
        key: '3',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL ',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

interface PageThreeFourPlanoAnualProps {}

const PageThreeFourPlanoAnual: React.FC<PageThreeFourPlanoAnualProps> = () => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={41} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3.4 NATAL
                </StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Natal é a capital e o município mais populoso do Rio Grande do Norte, com cerca de 751 mil habitantes, e principal
                            centro econômico do estado. Sua economia é impulsionada, principalmente, pelo setor de serviços, com destaque para o{' '}
                            <strong>turismo</strong>, e pelo comércio.
                        </p>
                        <p>
                            Apesar de ser um importante pólo regional, a capital lida com desafios sociais e econômicos. É nesse contexto que a
                            educação de qualidade se torna fundamental para mitigar os desafios encontrados no território, buscando garantir que
                            a riqueza gerada pela economia local seja convertida em mais oportunidades e melhor qualidade de vida para todos os
                            natalenses. É com esse objetivo que o <strong>Instituto Ayrton Senna</strong> estabeleceu uma{' '}
                            <strong>parceria</strong> com o município, visando
                            <strong>acelerar a qualidade da educação</strong> na Rede Municipal de Ensino.
                        </p>
                        <Image
                            src={fetchStorageFile('anexo_storage_files_7767466220170529056.webp_2025-11-20-1763662602787.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <h2>3.4.1 A EDUCAÇÃO NO MUNICÍPIO</h2>
                        <p>
                            Os indicadores educacionais no município revelam um cenário preocupante: além de serem significativamente inferiores
                            às médias nacionais, apresentam resultados piores do que a média do estado. A <strong>taxa de reprovação</strong>{' '}
                            merece destaque, alcançando{' '}
                            <strong>mais de 25% dos(as) estudantes nos anos finais do Ensino Fundamental em 2024,</strong> praticamente o mesmo
                            percentual que dez anos antes.
                        </p>
                        <StyledGlobal.TitleYellow>ACESSO</StyledGlobal.TitleYellow>
                        <StyledGlobal.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_17970614669851788355.png_2025-11-20-1763662803928.png')}
                                alt={`
                                    Quadro comparativo dos anos iniciais e finais do Ensino Fundamental, com ícones de escola, professor e matrícula. Nos anos iniciais: 61 escolas, 
                                    1.032 professores e 22.126 matrículas. Nos anos finais: 30 escolas, 767 professores e 12.883 matrículas. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={42} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '320px 1fr',
                        notebook: '320px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            O município não teve os resultados da avaliação de alfabetização divulgados em 2024 por não atingir os parâmetros
                            mínimos de participação. Em 2023, o percentual de estudantes alfabetizados(as) era de apenas 34,5%,{' '}
                            <strong>mais de 20 pontos percentuais abaixo da média nacional.</strong>
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_7065830018664423990.png_2025-11-20-1763663269455.png')}
                                alt={`Gráfico de barras verticais apresentando a taxa de alfabetização em 2023 para três recortes. Natal: 34,5%; Rio Grande do Norte: 37,2%; Brasil: 55,9%. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: MEC - Indicador Criança Alfabetizada. MEC/Inep - Censo Escolar.</p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                                <p>
                                    {' '}
                                    distorção idade-série caiu em Natal ao longo de 10 anos, tanto nos anos iniciais quanto nos anos finais do
                                    Ensino Fundamental, mas em ritmo mais lento do que o observado no estado do Rio Grande do Norte e no país.{' '}
                                    <strong>
                                        Em 2024, o percentual de estudantes atrasados no município ainda era de 39,4% nos anos finais, percentual
                                        acima da média do estado e quase o dobro da média nacional.
                                    </strong>{' '}
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.CardWhite2>
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_14859032891497580797.png_2025-11-20-1763663415105.png')}
                                    alt={`Gráfico de barras comparando a distorção idade-série em 2014 e 2024 para anos iniciais e anos finais em Natal e no Rio Grande do Norte. 
                                            Anos iniciais: 
                                            — Natal: 19% em 2014 e 12% em 2024. 
                                            — Rio Grande do Norte: 21% em 2014 e 12% em 2024. 
                                            Anos finais: 
                                            — Natal: 47% em 2014 e 39% em 2024. 
                                            — Rio Grande do Norte: 47% em 2014 e 34% em 2024. 
                                            As barras de 2014 aparecem em azul escuro e as de 2024 em azul claro, com setas indicando redução das taxas.” `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.CardWhite2>
                        </ResponsiveGrid>
                        <Image
                            style={{ width: '100%', height: '520px', objectFit: 'cover', objectPosition: 'center' }}
                            src={fetchStorageFile('anexo_storage_files_11190082061838015813.jpg_2025-11-20-1763663772078.jpg')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={43} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>APROVAÇÃO, REPROVAÇÃO E ABANDONO</StyledGlobal.TitleYellow>
                                <p>
                                    As taxas de aprovação são significativamente menores no Rio Grande do Norte, quando comparado à média
                                    nacional, especialmente nos anos finais do Ensino Fundamental, e a situação é ainda mais grave na sua
                                    capital, Natal. Isso se deve a uma{' '}
                                    <strong>variação pouco expressiva das taxas de reprovação no município nos últimos dez anos.</strong> Em
                                    2024, <strong>um em cada quatro estudantes reprovou ao longo dos anos finais do Ensino Fundamental.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.CardWhite2>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_13821383829811533342.png_2025-11-20-1763664459847.png')}
                                        alt={`Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando Natal, Rio Grande do Norte e Brasil. Nos anos iniciais, aprovação: Natal 91,9%, Rio Grande do Norte 93,3%, Brasil 96,9%. 
                                                Reprovação: Natal 7,1%, Rio Grande do Norte 6,1%, Brasil 2,8%. 
                                                Abandono: Natal 1%, Rio Grande do Norte 0,6%, Brasil 0,3%. 
                                                Nos anos finais, aprovação: Natal 72,6%, Rio Grande do Norte 79,9%, Brasil 92%.  
                                                Reprovação: Natal 25,2%, Rio Grande do Norte 17,9%, Brasil 6,6%. 
                                                Abandono: Natal 2,2%, Rio Grande do Norte 2,2%, Brasil 1,4%. `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            src={fetchStorageFile('anexo_storage_files_7199849285080414369.webp_2025-11-20-1763664537984.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                        <p>
                            Em 2023, os percentuais de estudantes com aprendizado adequado em Língua Portuguesa no 5º e no 9º ano do Ensino
                            Fundamental em Natal foram semelhantes àqueles observados na média do estado, 36,6% e 23,2%, respectivamente. Esses
                            percentuais são <strong>significativamente inferiores à média nacional.</strong>
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_14151001382766430051.png_2025-11-20-1763664717543.png')}
                                alt={`
                                    Conjunto de ícones de crianças representando a proporção de aprendizado adequado em Língua Portuguesa no 5º ano e 9º ano do Ensino Fundamental. 
                                    5º ano: Natal 36,6%, Rio Grande do Norte 36,9%, Brasil 54,2%. 
                                    9º ano: Natal 23,2%, Rio Grande do Norte 23,1%, Brasil 33,6%. 
                                    Uma parte dos ícones são pintados de azul de acordo com o percentual de cada território, para indicar os estudantes com nível adequado; o restante dos ícones está em cinza. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fontes: MEC/Inep - Censo Escolar. MEC/Inep - SAEB. Rede Municipal.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={44} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>
                            3.4.2 APRESENTAÇÃO DO <br /> PLANO ANUAL EM NATAL
                        </StyledGlobal.Title>
                        <p>
                            A parceria do Instituto Ayrton Senna com o município de Natal em 2025 ocorreu por meio da implementação de três
                            programas educacionais, como parte do Plano Anual Instituto Ayrton Senna, que busca contribuir para a superação dos
                            desafios da educação.
                        </p>

                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Quadro informativo apresentando o dado: mais de 36.9 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +36,9 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </StyledGlobal.TableWrapper>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={45} stylesContent={{ marginRight: '80px' }}>
                <h2>3.4.3 RESULTADOS</h2>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            O <strong>caráter inovador dos programas</strong> implementados pelo Instituto Ayrton Senna no escopo da parceria com
                            o município de Natal são valorizados pela equipe da secretaria da educação, que reforça como eles têm sido
                            importantes para <strong>efetivar a educação de qualidade</strong> para as crianças do município.
                        </p>
                        <p>
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                9 cursos presenciais com técnicos(as) da secretaria de educação, diretores(as), coordenadores(as) pedagógicos(as)
                            </strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            <strong>e professores(as),</strong> a fim de preparálos(as) para implementar os diferentes programas educacionais no
                            município: Gestão Nota 10, Se Liga e Acelera Brasil. Além disso, foram{' '}
                            <strong>realizados 16 cursos virtuais,</strong> para que os(as) educadores(as) tivessem acesso contínuo às formações.
                        </p>
                        <p>
                            Os(as) participantes avaliaram as formações de forma muito positiva, <br />{' '}
                            <strong style={{ fontSize: '24px' }}>alcançando um nível de satisfação médio de 76%.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além das formações sobre os programas educacionais, os(as) profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <div>
                            <StyledGlobal.CardGray
                                style={{ maxWidth: '250px' }}
                                role="img"
                                aria-label="Foram realizadas 11 oficinas presenciais e 11 oficinas virtuais"
                            >
                                <span> Foram realizadas</span> <strong>11 oficinas presenciais e 11 oficinas virtuais</strong>
                            </StyledGlobal.CardGray>
                        </div>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Quote
                            text={`
                            Tanto o conteúdo
                            exposto quanto
                            à forma como foi
                            abordado provocou
                            reflexões significativas
                            do trabalho na escola
                            me ajudando a pensar
                            em importantes ações
                            a serem desenvolvidas
                            no chão da escola.”
                            <br/>
                            <br/>
                            Depoimento de um(a) <br/>
                            participante dos cursos <br/>
                            presenciais
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={46} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Em Natal, a <strong>criação e institucionalização de um Comitê Gestor</strong> consolidou a governança e transformou
                            a análise de dados em prática permanente, envolvendo todos os agentes na apropriação das evidências, na
                            responsabilização e na construção de soluções. O comitê é composto pelo Secretário de Educação, por equipes da
                            Secretaria ligadas aos programas educacionais e por especialistas do Instituto Ayrton Senna.
                        </p>
                        <p>
                            Para que a gestão seja informada pelo cotidiano da sala de aula, cada programa especificou quais dados coletar e quem
                            deve acompanhá-los; além disso, uma{' '}
                            <strong>
                                plataforma de monitoramento centraliza as informações, viabilizando decisões rápidas voltadas ao desenvolvimento
                                integral dos estudantes.
                            </strong>
                        </p>
                        <p>
                            O perfil dos(as) estudantes atendidos(as) variou de acordo com o programa implementado, como mostram os gráficos ao
                            lado.
                        </p>
                        <Image
                            src={fetchStorageFile('anexo_storage_files_2467547151858596508.webp_2025-11-20-1763666819122.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2>
                            <h2 style={{ fontSize: '14px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_4826638768773487397.png_2025-11-20-1763666609558.png')}
                                    alt={`
                                        Gráfico de pizza representando distribuição de idades no programa Se Liga: 10 anos (13,9%), 11 anos (29,8%), 
                                        12 anos (29,9%), 13 anos (14,3%), 14 anos (8,1%) e 15 anos ou mais (4%). Cada fatia identifica a porcentagem por faixa etária. 
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_6927246590051926632.png_2025-11-20-1763666630741.png')}
                                    alt={`
                                        Gráfico de pizza mostrando a distribuição por idade dos estudantes do Acelera Brasil: 10 anos (4,5%), 11 anos (29%), 12 anos (41,5%), 
                                        13 anos (18,2%) e 14 anos (4%), 15 anos ou mais (2,8%). Cada fatia identifica a porcentagem por faixa etária. 
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </ResponsiveGrid>
                            <p>
                                As turmas do Acelera Brasil em Natal são compostas por estudantes entre 10 a 15 anos, com maior parcela de
                                estudantes com 12 anos (42%), equivalente ao 7º ano do Ensino Fundamental. 34% são estudantes mais novos(as),
                                entre 10 e 11 anos e 25% por estudantes mais velhos(as).
                            </p>
                            <br />
                            <p>
                                Já as turmas do Se Liga têm um percentual relativamente maior de estudantes mais novos(as): 14% com 10 anos e 30%
                                com 11 anos.
                            </p>
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={47} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 380px',
                        notebook: '1fr 380px',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Os programas já apresentam efeitos no sentido da melhoria no aprendizado dos(as) estudantes. No início da
                                    implementação do Se Liga,{' '}
                                    <strong>
                                        metade dos(as) alunos(as) tinham proficiência em Língua Portuguesa equivalente ao esperado para a
                                        Educação Infantil
                                    </strong>
                                    , enquanto a outra metade estava um nível acima, compatível com o 1º ano do Ensino{' '}
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Fundamental. Em setembro, <strong>esses percentuais caíram para 15%</strong> e 39% respectivamente, enquanto
                                    o percentual de estudantes que atingiram o nível quatro, mais alto da escala, chegou a 14%. Os resultados do
                                    Acelera Brasil também são importantes:{' '}
                                    <strong>entre maio e setembro, o percentual de estudantes fluentes em leitura aumentou quase 40</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    <strong>pontos percentuais.</strong> Em relação à escrita, o percentual de alunos(as) que escrevia palavras
                                    com sílabas complexas ortograficamente aumentou quase 30 pontos e o percentual que conseguia escrever textos
                                    com frases ampliadas, com desenvolvimento lógico de ideias interligadas por conectivos, passou de apenas 3%
                                    para 27%.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={320}
                            style={{ objectFit: 'cover', objectPosition: '70% 50%' }}
                            src={fetchStorageFile('anexo_storage_files_10466947941706268008.webp_2025-11-20-1763667228087.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <StyledGlobal.CardWhite2 style={{ gap: '40px' }}>
                    <h2>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                    <ResponsiveGrid
                        templates={{
                            desktop: '1fr 1fr',
                            notebook: '1fr 1fr',
                            tablet: '1fr',
                        }}
                        styles={{ margin: 0, gap: '40px' }}
                    >
                        <Image
                            style={{
                                display: 'flex',
                                alignSelf: 'center',
                                justifySelf: 'center',
                                width: '70%',
                            }}
                            src={fetchStorageFile('anexo_storage_files_8674404993772938966.png_2025-11-20-1763668915148.png')}
                            alt={`
                                Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes do Se Liga no nível mais baixo em língua portuguesa. 
                                Texto que acompanha o primeiro grupo diz: ‘Em fevereiro, 50% dos estudantes do Se Liga estavam no nível mais baixo de Língua Portuguesa’ 
                                Texto que acompanha o segundo grupo diz: ‘Em setembro, o número chegou a 15%, ou seja, a maioria evoluiu de nível’ 
                                `}
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                        <Image
                            style={{
                                display: 'flex',
                                width: '30%',
                                alignSelf: 'center',
                                justifySelf: 'center',
                            }}
                            src={fetchStorageFile('anexo_storage_files_3145812787254123554.png_2025-11-20-1763668949046.png')}
                            alt={`
                                Quadro informativo com texto destacando o avanço no programa Acelera Brasil. A mensagem indica que, entre maio e setembro, 
                                o percentual de estudantes fluentes em leitura aumentou quase 40 pontos percentuais; uma seta voltada para cima reforça o crescimento. 
                                `}
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </ResponsiveGrid>
                </StyledGlobal.CardWhite2>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={48} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            As evidências indicam que os programas impulsionam a alfabetização e o progresso escolar, favorecendo que alunos em
                            maior vulnerabilidade avancem de forma mais segura e autônoma, o que eleva a probabilidade de{' '}
                            <strong>concluírem a educação básica e de exercerem sua cidadania.</strong>
                        </p>
                        <p>
                            O sucesso dos programas apresentado anteriormente foi potencializado pela estratégia de{' '}
                            <strong>distribuição de livros para os(as) estudantes.</strong> Em 2025, foram mais de 6 mil livros distribuídos,
                            sendo <strong>2.189 livros pedagógicos e 4.060 livros de literatura infanto-juvenil</strong>, incluindo exemplares
                            com conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                        </p>
                        <StyledGlobal.CardWhite2 style={{}}>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_11222452005411601879.png_2025-11-20-1763669869817.png')}
                                alt={`
                                    Quadro com quatro ícones de livros indicando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. 
                                    Acelera Brasil: 1.414 livros; Se Liga: 775 livros; Livros de Literatura: 4.060 livros 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2 style={{ padding: '20px', gap: '40px' }}>
                            <h2 style={{ fontSize: '18px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_6943944979859312549.png_2025-11-20-1763669932154.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={49} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Um desdobramento concreto e mensurado pelas estratégias de monitoramento é o{' '}
                            <strong>aumento considerável da prática leitora</strong> pelos(as) estudantes atendidos. No Se Liga, a média de
                            livros lidos por aluno(a) ao mês passou de 2,1 para 3,8 entre maio a setembro.
                        </p>

                        <StyledGlobal.CardWhite2 style={{ height: '280px' }}>
                            <Image
                                height={'100%'}
                                style={{ objectFit: 'cover' }}
                                src={fetchStorageFile('anexo_storage_files_15121142192129101842.png_2025-11-21-1763726703332.png')}
                                alt={`
                                    Conjunto de ícones de livros para comparar a média de livros lidos por estudante antes e depois da participação no Se Liga. 
                                    O número de livros lidos aumentou de 2,1 para 3,8 livros por estudante, com seta indicando ‘1,8 vezes mais’.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <Image
                            height={400}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_6880804097941531570.webp_2025-11-21-1763726774562.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além dos efeitos sobre a alfabetização e aumento da proficiência, a prática da leitura, potencializada pelo acesso à
                            um acervo diversificado amplia o{' '}
                            <strong>repertório cultural, contribuindo ainda mais para o desenvolvimento integral dessas crianças.</strong>
                        </p>
                        <p>
                            Como resultado do programa Acelera Brasil, foi criado um <strong>curtametragem</strong> que registra as vivências dos
                            estudantes em atividades voltadas à valorização do patrimônio cultural de seu território. O processo de produção
                            envolveu descobertas, trocas e reflexões sobre a importância da memória coletiva e das tradições locais. Ao
                            reconhecerem a força de sua própria cultura, os alunos fortaleceram o senso de pertencimento e ampliaram o olhar
                            sobre a comunidade à qual pertencem.
                        </p>
                        <p>
                            As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas com nota máxima pela equipe da Secretaria de
                            Educação, com <strong>100% de satisfação em todos os aspectos analisados.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={50} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <ResponsiveGrid
                        templates={{
                            desktop: '1fr 1fr',
                            tablet: '1fr',
                        }}
                        styles={{ margin: 0, gap: '40px' }}
                    >
                        <StyledGlobal.ContentColumn>
                            <p>
                                Aos 10 anos, <strong>Raymily</strong> ainda não conseguia ler e escrever, fato que gerava frustração não só na
                                escola, como fora dela, de acordo com relatos de sua avó Edileuza. Graças à abordagem diferenciada do Se Liga,
                                programa no qual ingressou no início do ano, Raymily já demonstra avanços consistentes na leitura e escrita.
                            </p>
                            <p>Seu professor, Elton, evidencia esse diferencial:</p>
                            <Quote
                                text={`
                                O programa é totalmente
                                adequado para que o aluno fixe
                                bem aquele conteúdo; pra que ele
                                compreenda bem porque respeita
                                os níveis em que cada aluno está."
                                
                                `}
                            />
                        </StyledGlobal.ContentColumn>
                        <StyledGlobal.ContentColumn>
                            <Image
                                height={400}
                                style={{ objectFit: 'cover', objectPosition: '50% 20%' }}
                                src={fetchStorageFile('anexo_storage_files_11465218781112202761.jpg_2025-11-21-1763727905893.jpg')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <CardQRcodeVideosPlanoAnual />
                        </StyledGlobal.ContentColumn>
                    </ResponsiveGrid>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <Image
                                    height={400}
                                    style={{ objectFit: 'cover', objectPosition: '50% 20%' }}
                                    src={fetchStorageFile('anexo_storage_files_16248235725895424313.webp_2025-11-21-1763728113823.webp')}
                                    alt=""
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Apesar de já estar com 11 anos, idade esperada para o sexto ano do Ensino Fundamental, <strong>Paulo</strong>{' '}
                                    não foi alfabetizado na idade adequada, o que também causou atraso escolar. Visando recuperar a defasagem,
                                    Paulo foi encaminhado para uma turma do Se Liga em 2025 e os resultados em aprendizagem e comportamento não
                                    podiam ser mais evidentes.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Quote
                            text={`
                            Depois que eu aprendi a ler, eu pensei
                            ‘Meu Deus, a Professora Camila está
                            me ajudando muito!’, aí eu falei que
                            vou seguir meu estudo, vou aprender
                            a ler muito e vamos simbora!”

                            
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeFourPlanoAnual;
